import { Condition } from '../Questionnaires/QuestionnairesList/components/types';
import { ConditionSelectorOption } from './interface';

export function isString(value: any): value is string {
  return typeof value === 'string';
}

export function getSelectedOption(
  selectedConditionId: string,
  conditions: Condition[],
  selectedCondition?: Condition | null
) {
  if (selectedConditionId === null) return null;

  if (selectedConditionId) {
    const selectedQuestionnaireById = findSelectedConditionById(conditions, selectedConditionId);

    if (selectedQuestionnaireById) {
      return createQuestionnaireOption(selectedQuestionnaireById);
    }
  }

  if (selectedCondition) {
    return createQuestionnaireOption(selectedCondition);
  }
}

function findSelectedConditionById(conditions: Condition[], selectedConditionId: string) {
  return conditions.find(condition => condition._id === selectedConditionId);
}

export function createOptions(questionnaires: Condition[], selectedCondition?: Condition | null) {
  const options: ConditionSelectorOption[] = [createEmptyOption()];

  if (selectedCondition) {
    options.push(createQuestionnaireOption(selectedCondition));
  }

  return options.concat(mapConditionsToOptions(questionnaires));
}

function mapConditionsToOptions(questionnaires: Condition[]): ConditionSelectorOption[] {
  return questionnaires.map(createQuestionnaireOption);
}

function createQuestionnaireOption(condition: Condition): ConditionSelectorOption {
  return {
    value: condition._id,
    label: condition.name
  };
}

function createEmptyOption(): ConditionSelectorOption {
  return {
    value: null,
    label: 'None'
  };
}
